module.exports = __webpack_public_path__ + "components/page-footer/static/surf-icon-background-e9090bfc605a5f10f84b87b8b05a3392.svg";